import { Feature, Geometry } from 'geojson';
import {
  GeofenceFilters,
  GeofenceProperties,
  useGetGeofencesGeoJsonQuery,
} from '@casops/store/apis/geofencesApi';
import { ReactElement, useCallback } from 'react';
import GeofenceLayerGroup from '../geofence-layer-group/GeofenceLayerGroup';
import GeofenceInteractiveLayer from '../geofence-interactive-layer/GeofenceInteractiveLayer';
import useFilters from '@casops/filters/useFilters';
import { FilterGroup } from '@casops/filters/types';

interface OtherGeofenceLayerGroupsProps {
  id?: number;
  checked?: boolean;
  excludeSelected?: boolean;
}

export function OtherGeofencesLayerGroup({
  id,
  checked = true,
  excludeSelected = false,
}: OtherGeofenceLayerGroupsProps): ReactElement | null {
  const geofenceFilters = useFilters<GeofenceFilters>(FilterGroup.Geofences);

  // Cache this for a while as it doesn't change frequently and it's chunky.
  const { data: geoJson } = useGetGeofencesGeoJsonQuery(
    { query: geofenceFilters },
    {
      refetchOnMountOrArgChange: 1800,
    },
  );

  const filterOutCurrentGeofence = useCallback(
    (feature: Feature<Geometry, GeofenceProperties>): boolean => {
      return feature.properties.id !== id;
    },
    [id],
  );

  return typeof geoJson !== 'undefined' ? (
    <GeofenceLayerGroup
      key="geo-other"
      checked={checked}
      geoJson={geoJson}
      filter={typeof id === 'number' && excludeSelected ? filterOutCurrentGeofence : undefined}
      LayerComponent={GeofenceInteractiveLayer}
    />
  ) : null;
}

export default OtherGeofencesLayerGroup;
